import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { tx, useLang } from "../lib/i18n";

const sel = "w-full rounded-xl border border-[var(--mv-border-2)] bg-[var(--mv-bg)] px-3 py-2.5 text-sm outline-none focus:border-[var(--mv-teal)]";

export const AddFunds = () => { useLang();
  const [d, setD] = useState(null);
  const [asset, setAsset] = useState("");
  const [route, setRoute] = useState("");
  useEffect(() => { api.get("/deposit-routes").then((r) => setD(r.data)).catch((e) => setD({ error: errMsg(e) })); }, []);
  if (!d) return <p className="text-xs text-[var(--mv-dim)]">{tx("Loading…")}</p>;
  if (d.error) return <p className="text-xs text-red-300">{tx(d.error)}</p>;
  const a = d.assets.find((x) => x.asset === asset);
  const net = a?.networks.find((n) => n.route_id === route);
  return (
    <div className="rounded-2xl border border-[var(--mv-border)] bg-[var(--mv-card)] p-5" data-testid="add-funds-panel">
      <p className="text-sm font-semibold">{tx("Add Funds")}</p>
      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        <label className="text-xs text-[var(--mv-dim)]">{tx("1. Select currency")}
          <select className={`${sel} mt-1`} value={asset} onChange={(e) => { setAsset(e.target.value); setRoute(""); }} data-testid="add-funds-asset">
            <option value="">—</option>{d.assets.map((x) => <option key={x.asset} value={x.asset}>{x.asset} · {tx(x.name)}</option>)}
          </select></label>
        <label className="text-xs text-[var(--mv-dim)]">{tx("2. Select blockchain network")}
          <select className={`${sel} mt-1`} value={route} disabled={!a} onChange={(e) => setRoute(e.target.value)} data-testid="add-funds-network">
            <option value="">{a && a.networks.length === 0 ? tx("No network configured") : "—"}</option>
            {(a?.networks || []).map((n) => <option key={n.route_id} value={n.route_id}>{n.network_name}{n.token_standard ? ` (${n.token_standard})` : ""}</option>)}
          </select></label>
      </div>
      {a && (a.networks.length === 0 || net) && !net?.available && (
        <div className="mt-4 rounded-xl border border-amber-300/40 bg-amber-300/5 p-3 text-xs text-amber-200" data-testid="add-funds-unavailable">
          <p className="font-semibold">{tx(d.reason)}</p>
          <p className="mt-1">{tx("No receiving address or QR code is shown until this route is verified and approved for real deposits. Your balance does not change.")}</p>
          <Link to="/messages" className="mt-2 inline-block text-[var(--mv-teal)]" data-testid="add-funds-support">{tx("Contact MIVO Support →")}</Link>
        </div>
      )}
      <p className="mt-4 flex gap-2 text-[11px] text-[var(--mv-dim)]" data-testid="add-funds-warning"><AlertTriangle className="h-4 w-4 shrink-0 text-amber-300" />{tx(d.warning)}</p>
    </div>
  );
};
